// /* eslint-disable react/react-in-jsx-scope */

// import Dashboard from 'pages/Dashboard';
// import Profile from 'pages/Profile';

// import NotAuthorised from 'pages/NotAuthorised';

// import RoleBasedPage from 'pages/RareUsedComponents/RoleBasedPage';
// import UpdatePassword from 'pages/UpdatePassword';
// import Orders from 'pages/Orders';

// import Notifications from 'pages/Notifications';
// import BiddingOrders from 'pages/BiddingOrders';
// import Products from 'pages/Products';
// import Staff from 'pages/Staff';
// import Invoices from 'pages/Invoices';
// import Vendor from 'pages/Vendor';
// import MarketListing from 'pages/MarketListing';
// import PageNotFound from 'pages/PageNotFound';
// import ApplicationUI from 'pages/ApplicationUI';
// import SubscriptionPlans from 'pages/SubscriptionPlans';
// // import Subscribers from 'pages/Subscribers';
// import Addons from 'pages/Addons';
// import OfferCoupons from 'pages/OfferCoupons';
// import FeedbackHub from 'pages/FeedbackHub';
// import RateCardManagement from 'pages/RateCardManagement';

// // import WebPayment from 'pages/WebPayment';
// import { role as Role } from './role';

// export const ALL_ROUTES = [
//   // {
//   //   // exact: true,
//   //   path: '/',
//   //   component: <Dashboard />,
//   //   requiredRoles: [
//   //     Role.ADMIN,
//   //     Role.SUPER_ADMIN,
//   //     // Role.ACCOUNT,
//   //     // Role.LOGISTICS,
//   //     // Role.SALES,
//   //     // Role.TRADER,
//   //   ],
//   // },
//   {
//     // exact: true,
//     path: '/dashboard',
//     component: <Dashboard />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       // Role.ACCOUNT,
//       // Role.LOGISTICS,
//       // Role.SALES,
//       // Role.TRADER,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/biddings',
//     component: <BiddingOrders />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/products',
//     component: <Products />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     // exact: true,
//     path: '/orders',
//     component: <Orders />,
//     requiredRoles: [
//       Role.SUPER_ADMIN,
//       Role.ADMIN,
//       Role.LOGISTICS,
//       Role.ACCOUNT,
//       Role.SALES_EXECUTIVE,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/profile',
//     component: <Profile />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },

//   {
//     path: '/unauthorized',
//     component: <NotAuthorised />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.LOGISTICS,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//     ],
//   },
//   {
//     path: '/role-based-page',
//     component: <RoleBasedPage />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/update-password',
//     component: <UpdatePassword />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     // exact: true,
//     path: '/staff',
//     component: <Staff />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     // exact: true,
//     path: '/invoices',
//     component: <Invoices />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.ACCOUNT, Role.LOGISTICS],
//   },
//   {
//     // exact: true,
//     path: '/vendors',
//     component: <Vendor />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/market-listing',
//     component: <MarketListing />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//       Role.BDE,
//     ],
//   },

//   {
//     // exact: true,
//     path: '/application-ui',
//     component: <ApplicationUI />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     // exact: true,
//     path: '/notification',
//     component: <Notifications />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_HEAD,
//       Role.SALES_EXECUTIVE,
//     ],
//   },
//   {
//     path: '/plans',
//     component: <SubscriptionPlans />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/add-ons',
//     component: <Addons />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/coupons',
//     component: <OfferCoupons />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/feedback-hub',
//     component: <FeedbackHub />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     path: '/rate-card-management',
//     component: <RateCardManagement />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   // {
//   //   path: '/plans',
//   //   component: <SubscriptionPlans />,
//   //   requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   // },
//   // {
//   //   path: '/subscribers',
//   //   component: <Subscribers />,
//   //   requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   // },
//   {
//     // exact: true,   // new added
//     path: '*',
//     component: <PageNotFound />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.ACCOUNT, Role.LOGISTICS],
//   },
// ];

// /* eslint-disable react/react-in-jsx-scope */

// import Dashboard from 'pages/Dashboard';
// import Profile from 'pages/Profile';

// import NotAuthorised from 'pages/NotAuthorised';

// import RoleBasedPage from 'pages/RareUsedComponents/RoleBasedPage';
// import UpdatePassword from 'pages/UpdatePassword';
// import Orders from 'pages/Orders';

// import Notifications from 'pages/Notifications';
// import BiddingOrders from 'pages/BiddingOrders';
// import Products from 'pages/Products';
// import Staff from 'pages/Staff';
// import Invoices from 'pages/Invoices';
// import Vendor from 'pages/Vendor';
// import MarketListing from 'pages/MarketListing';
// import PageNotFound from 'pages/PageNotFound';
// import ApplicationUI from 'pages/ApplicationUI';
// import SubscriptionPlans from 'pages/SubscriptionPlans';
// // import Subscribers from 'pages/Subscribers';
// import Addons from 'pages/Addons';
// import OfferCoupons from 'pages/OfferCoupons';
// import FeedbackHub from 'pages/FeedbackHub';
// import RateCardManagement from 'pages/RateCardManagement';
// import EditList from 'pages/Staff/components/EditRole/index'; // Import EditRole component
// import AddRole  from 'pages/Staff/components/EditRole/Addrole';
// import EditRole from 'pages/Staff/components/EditRole/Editrole';

// // import WebPayment from 'pages/WebPayment';
// import { role as Role } from './role';

// export const ALL_ROUTES = [
//   {
//     // exact: true,
//     path: '/dashboard',
//     component: <Dashboard />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       // Role.ACCOUNT,
//       // Role.LOGISTICS,
//       // Role.SALES,
//       // Role.TRADER,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/biddings',
//     component: <BiddingOrders />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/products',
//     component: <Products />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     // exact: true,
//     path: '/orders',
//     component: <Orders />,
//     requiredRoles: [
//       Role.SUPER_ADMIN,
//       Role.ADMIN,
//       Role.LOGISTICS,
//       Role.ACCOUNT,
//       Role.SALES_EXECUTIVE,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/profile',
//     component: <Profile />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },

//   {
//     path: '/unauthorized',
//     component: <NotAuthorised />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.LOGISTICS,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//     ],
//   },
//   {
//     path: '/role-based-page',
//     component: <RoleBasedPage />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/update-password',
//     component: <UpdatePassword />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     // exact: true,
//     path: '/staff',
//     component: <Staff />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     // NEW ROUTE FOR EDIT ROLE
//     path: '/staff/edit-list',
//     component: <EditList />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//     {
//     // NEW ROUTE FOR ADD ROLE - YEH ADD KARO
//     path: '/staff/add-role',
//     component: <AddRole />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//     {
//     // NEW ROUTE FOR EDIT ROLE
//     path: '/staff/edit-role',
//     component: <EditRole />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },

//   {
//     // exact: true,
//     path: '/invoices',
//     component: <Invoices />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.ACCOUNT, Role.LOGISTICS],
//   },
//   {
//     // exact: true,
//     path: '/vendors',
//     component: <Vendor />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//       Role.BDE,
//     ],
//   },
//   {
//     // exact: true,
//     path: '/market-listing',
//     component: <MarketListing />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_EXECUTIVE,
//       Role.SALES_HEAD,
//       Role.BDE,
//     ],
//   },

//   {
//     // exact: true,
//     path: '/application-ui',
//     component: <ApplicationUI />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     // exact: true,
//     path: '/notification',
//     component: <Notifications />,
//     requiredRoles: [
//       Role.ADMIN,
//       Role.SUPER_ADMIN,
//       Role.SALES_HEAD,
//       Role.SALES_EXECUTIVE,
//     ],
//   },
//   {
//     path: '/plans',
//     component: <SubscriptionPlans />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/add-ons',
//     component: <Addons />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/coupons',
//     component: <OfferCoupons />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN],
//   },
//   {
//     path: '/feedback-hub',
//     component: <FeedbackHub />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     path: '/rate-card-management',
//     component: <RateCardManagement />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.SALES_HEAD],
//   },
//   {
//     // exact: true,   // new added
//     path: '*',
//     component: <PageNotFound />,
//     requiredRoles: [Role.ADMIN, Role.SUPER_ADMIN, Role.ACCOUNT, Role.LOGISTICS],
//   },
// ];

// /* eslint-disable react/react-in-jsx-scope */

// import Dashboard from 'pages/Dashboard';
// import Profile from 'pages/Profile';
// import NotAuthorised from 'pages/NotAuthorised';
// import RoleBasedPage from 'pages/RareUsedComponents/RoleBasedPage';
// import UpdatePassword from 'pages/UpdatePassword';
// import Orders from 'pages/Orders';
// import Notifications from 'pages/Notifications';
// import BiddingOrders from 'pages/BiddingOrders';
// import Products from 'pages/Products';
// import Staff from 'pages/Staff';
// import Invoices from 'pages/Invoices';
// import Vendor from 'pages/Vendor';
// import MarketListing from 'pages/MarketListing';
// import PageNotFound from 'pages/PageNotFound';
// import ApplicationUI from 'pages/ApplicationUI';
// import SubscriptionPlans from 'pages/SubscriptionPlans';
// import Addons from 'pages/Addons';
// import OfferCoupons from 'pages/OfferCoupons';
// import FeedbackHub from 'pages/FeedbackHub';
// import RateCardManagement from 'pages/RateCardManagement';
// import EditList from 'pages/Staff/components/EditRole/index';
// import AddRole from 'pages/Staff/components/EditRole/Addrole';
// import EditRole from 'pages/Staff/components/EditRole/Editrole';

// import { role as Role } from './role';

// export const ALL_ROUTES = [
//   {
//     path: '/dashboard',
//     component: <Dashboard />,
//     showInSidebar: true,
//   },
//   {
//     path: '/biddings',
//     component: <BiddingOrders />,

//   },
//   {
//     path: '/products',
//     component: <Products />,
//   },
//   {
//     path: '/orders',
//     component: <Orders />,
//   },
//   {
//     path: '/profile',
//     component: <Profile />,
//   },
//   {
//     path: '/unauthorized',
//     component: <NotAuthorised />,
//   },
//   {
//     path: '/role-based-page',
//     component: <RoleBasedPage />,

//   },
//   {
//     path: '/update-password',
//     component: <UpdatePassword />,

//   },
//   {
//     path: '/staff',
//     component: <Staff />,

//   },
//   {
//     path: '/staff/edit-list',
//     component: <EditList />,

//   },
//   {
//     path: '/staff/add-role',
//     component: <AddRole />,

//   },
//   {
//     path: '/staff/edit-role',
//     component: <EditRole />,

//   },
//   {
//     path: '/invoices',
//     component: <Invoices />,

//   },
//   {
//     path: '/vendors',
//     component: <Vendor />,

//   },
//   {
//     path: '/market-listing',
//     component: <MarketListing />,

//   },
//   {
//     path: '/application-ui',
//     component: <ApplicationUI />,

//   },
//   {
//     path: '/notification',
//     component: <Notifications />,

//   },
//   {
//     path: '/plans',
//     component: <SubscriptionPlans />,

//   },
//   {
//     path: '/add-ons',
//     component: <Addons />,

//   },
//   {
//     path: '/coupons',
//     component: <OfferCoupons />,

//   },
//   {
//     path: '/feedback-hub',
//     component: <FeedbackHub />,

//   },
//   {
//     path: '/rate-card-management',
//     component: <RateCardManagement />,

//   },
//   {
//     path: '*',
//     component: <PageNotFound />,

//   },
// ];

/* eslint-disable react/react-in-jsx-scope */
import Dashboard from 'pages/Dashboard';
import Profile from 'pages/Profile';
import NotAuthorised from 'pages/NotAuthorised';
import RoleBasedPage from 'pages/RareUsedComponents/RoleBasedPage';
import UpdatePassword from 'pages/UpdatePassword';
import Orders from 'pages/Orders';
import Notifications from 'pages/Notifications';
import BiddingOrders from 'pages/BiddingOrders';
import Products from 'pages/Products';
import Staff from 'pages/Staff';
import Invoices from 'pages/Invoices';
import CRMLead from 'pages/CRMLead';
import Vendor from 'pages/Vendor';
import MarketListing from 'pages/MarketListing';
import PageNotFound from 'pages/PageNotFound';
import ApplicationUI from 'pages/ApplicationUI';
import SubscriptionPlans from 'pages/SubscriptionPlans';
import Addons from 'pages/Addons';
import OfferCoupons from 'pages/OfferCoupons';
import FeedbackHub from 'pages/FeedbackHub';
import RateCardManagement from 'pages/RateCardManagement';
import EditList from 'pages/Staff/components/EditRole/index';
import AddRole from 'pages/Staff/components/EditRole/Addrole';
import EditRole from 'pages/Staff/components/EditRole/Editrole';
import StaffChat from 'pages/Staff/components/StaffChat';
// ⭐ NEW: Import Analytics page
import Analytics from 'pages/Analytics';
import DeliveredRate from 'pages/DeliveredRate';
import AIChatBot from 'pages/AIChatBot';
import TaskBoard from 'pages/Task';
import OrderDetailsPage from 'pages/Orders/components/OrderDetailsPage';
import Settings from 'pages/Settings';
import Chat from 'pages/Chat';

export const ALL_ROUTES = [
  {
    path: '/dashboard',
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    path: '/chat',
    component: <Chat />,
    showInSidebar: true,
    requiredPermissions: ['WHATSAPP_CHAT_ACCESS', 'WHATSAPP_CHAT'],
  },
  // ⭐ NEW: Analytics Route
  {
    path: '/ai-chat-bot',
    component: <AIChatBot />,
    showInSidebar: true,
  },
  {
    path: '/analytics',
    component: <Analytics />,
    showInSidebar: true,
  },
  {
    path: '/delivered-rate',
    component: <DeliveredRate />,
    showInSidebar: true,
  },
  {
    path: '/task',
    component: <TaskBoard />,
    showInSidebar: true,
  },
  {
    path: '/biddings',
    component: <BiddingOrders />,
  },
  {
    path: '/products',
    component: <Products />,
  },
  {
    path: '/orders',
    component: <Orders />,
  },
  {
    path: '/orders/:orderId',
    component: <OrderDetailsPage />,
  },
  {
    path: '/profile',
    component: <Profile />,
  },
  {
    path: '/unauthorized',
    component: <NotAuthorised />,
  },
  {
    path: '/role-based-page',
    component: <RoleBasedPage />,
  },
  {
    path: '/update-password',
    component: <UpdatePassword />,
  },
  {
    path: '/staff',
    component: <Staff />,
  },
  {
    path: '/staff/edit-list',
    component: <EditList />,
  },
  {
    path: '/staff/add-role',
    component: <AddRole />,
  },
  {
    path: '/staff/edit-role',
    component: <EditRole />,
  },
  {
    path: '/staff-chat',
    component: <StaffChat />,
  },
  {
    path: '/staff-chat/:id',
    component: <StaffChat />,
  },
  {
    path: '/invoices',
    component: <Invoices />,
  },
  {
    path: '/leads',
    component: <CRMLead />,
  },
  {
    path: '/vendors',
    component: <Vendor />,
  },
  {
    path: '/market-listing',
    component: <MarketListing />,
  },
  {
    path: '/application-ui',
    component: <ApplicationUI />,
  },
  {
    path: '/notification',
    component: <Notifications />,
  },
  {
    path: '/plans',
    component: <SubscriptionPlans />,
  },
  {
    path: '/add-ons',
    component: <Addons />,
  },
  {
    path: '/coupons',
    component: <OfferCoupons />,
  },
  {
    path: '/feedback-hub',
    component: <FeedbackHub />,
  },
  {
    path: '/rate-card-management',
    component: <RateCardManagement />,
  },
  {
    path: '/settings',
    component: <Settings />,
  },
  {
    path: '*',
    component: <PageNotFound />,
  },
];
